import { render, staticRenderFns } from "./TopAside.vue?vue&type=template&id=2631d3df&scoped=true&"
import script from "./TopAside.vue?vue&type=script&lang=js&"
export * from "./TopAside.vue?vue&type=script&lang=js&"
import style0 from "./TopAside.vue?vue&type=style&index=0&id=2631d3df&lang=scss&scoped=true&"
import style1 from "./TopAside.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2631d3df",
  null
  
)

export default component.exports